import { RouterModule, Route } from '@angular/router';
import { ModuleWithProviders, ReflectiveInjector } from '@angular/core';
import { AppComponent } from './app.component';
import { AppMain } from 'app/app.main';

export const routes = [
    {
        path: '',
        component: AppComponent
    },
    { path:'**', redirectTo: '' }
];

export const routesProvider: ModuleWithProviders = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// ./src/app/app.routes.ts